import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {Modal,Fade,Backdrop} from '@mui/material';
import {
  Button,
  Paper,
  TextField,
  Grid,
} from "@material-ui/core";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { updateTubeStatus } from "../../actions/LimsAdminActions";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    marginTop: "2rem",
    padding: "0.5rem 2rem",
    width: "70%",
    zIndex:1
  },
  head: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "2rem",
  },
}));
interface Props {
  updateTubeStatus: any;
}
type ModalProps = {
  setOpen: Function;
  open: boolean;
  codeData: any;
  setCodeData: any;
  updateTubeStatus: any;
  setTubeId: any;
  tubeId: any;
  setUpdateTube: any;
  id: any;
};

const CreatePhlebo: React.FC<ModalProps> = ({
  setOpen,
  open,
  codeData,
  setCodeData,
  updateTubeStatus,
  setTubeId,
  setUpdateTube,
  tubeId,
  id,
}) => {
  const classes = useStyles();
  const handleClose = () => {
    setOpen(false);
  };

  const submitForm = async (e: any) => {
    e.preventDefault();
    const tubeData = {
      code: codeData,
      is_snr: false,
    };
    await updateTubeStatus(id, tubeData);
    setTubeId(tubeId);
    setUpdateTube(id);
    setOpen(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <Paper elevation={5} className={classes.paper}>
              <div className={classes.head}>
                <h4
                  style={{
                    marginBottom: "1rem",
                  }}
                  id="transition-modal-title"
                >
                  EDIT TUBE CODE
                </h4>
                <CloseSharpIcon onClick={() => setOpen(false)} />
              </div>
              <form onSubmit={submitForm}>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="flex-end"
                  spacing={3}
                  style={{ margin: "1rem auto", background: "#eff" }}
                >
                  <Grid
                    container
                    item
                    xs={12}
                    md={6}
                    spacing={3}
                    style={{ margin: "1rem 0", width: "100%", padding: "1rem" }}
                  >
                    <Grid item xs={12} style={{ padding: "0" }}>
                      <p>Code</p>
                    </Grid>
                    <Grid item xs={12} style={{ padding: "0" }}>
                      <TextField
                        name="bill_id"
                        type="text"
                        placeholder="Bill Id"
                        value={codeData}
                        variant="outlined"
                        style={{ margin: "0", width: "100%" }}
                        onChange={(e) => setCodeData(e.target.value as String)}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={12}
                    md={6}
                    spacing={3}
                    style={{ margin: "1rem 0", width: "100%", padding: "1rem" }}
                  >
                    <Grid item xs={12} style={{ padding: "0" }}>
                      <Button color="primary" type="submit" variant="contained">
                        Update Code
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, {
  updateTubeStatus,
})(CreatePhlebo);
